import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { TOOLTIP_PROTAL_ID } from '../constants';

const portalHolder = document.createElement('div');
const TooltipPortal = (props) => {
    useEffect(() => {
        const tooltipPortalRoot = document.getElementById(TOOLTIP_PROTAL_ID);
        tooltipPortalRoot.appendChild(portalHolder);
        return () => {
            if (tooltipPortalRoot.contains(portalHolder)) {
                tooltipPortalRoot.removeChild(portalHolder);
            }
        };
    }, []);
    return (ReactDOM.createPortal(
        props.children,
        portalHolder
    ));
};

export default TooltipPortal;
